export default {
  NEXT_PAGE: "PAGINATION/NEXT_PAGE",
  PREVIOUS_PAGE: "PAGINATION/PREVIOUS_PAGE",
  SET_PAGE: "PAGINATION/SET_PAGE",
  RESET: "PAGINATION/RESET",
  TOGGLE_LOADING: "PAGINATION/TOGGLE_LOADING",
  SET_INITIAL: "PAGINATION/SET_INITIAL",
};
